/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecipientStatus } from './RecipientStatus';
import {
    RecipientStatusFromJSON,
    RecipientStatusFromJSONTyped,
    RecipientStatusToJSON,
    RecipientStatusToJSONTyped,
} from './RecipientStatus';

/**
 * 
 * @export
 * @interface PatientJourneyRecipient
 */
export interface PatientJourneyRecipient {
    /**
     * The recipient's `Recipient.participant_id` on a sent entry, used to open that recipient's thread. Null on received entries.
     */
    participant_id: string | null;
    /**
     * 
     */
    name: string | null;
    /**
     * 
     */
    status: RecipientStatus | null;
    /**
     * 
     */
    admission_status: string | null;
}



/**
 * Check if a given object implements the PatientJourneyRecipient interface.
 */
export function instanceOfPatientJourneyRecipient(value: object): value is PatientJourneyRecipient {
    if (!('participant_id' in value) || value['participant_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('admission_status' in value) || value['admission_status'] === undefined) return false;
    return true;
}

export function PatientJourneyRecipientFromJSON(json: any): PatientJourneyRecipient {
    return PatientJourneyRecipientFromJSONTyped(json, false);
}

export function PatientJourneyRecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientJourneyRecipient {
    if (json == null) {
        return json;
    }
    return {
        
        'participant_id': json['participant_id'],
        'name': json['name'],
        'status': RecipientStatusFromJSON(json['status']),
        'admission_status': json['admission_status'],
    };
}

export function PatientJourneyRecipientToJSON(json: any): PatientJourneyRecipient {
    return PatientJourneyRecipientToJSONTyped(json, false);
}

export function PatientJourneyRecipientToJSONTyped(value?: PatientJourneyRecipient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'participant_id': value['participant_id'],
        'name': value['name'],
        'status': RecipientStatusToJSON(value['status']),
        'admission_status': value['admission_status'],
    };
}

